module.exports = __webpack_public_path__ + "img/support.2e65e308.svg";